module.exports = __webpack_public_path__ + "media/images/check-6ee44b3c28d3df0d9148c4ea4d045562.svg";